import React from "react";
import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Button } from "@mui/material";
import { FaRegHeart } from "react-icons/fa";
import { styled } from "@mui/system";
import { Card, CardContent, Typography, Box } from "@mui/material";
import { HeaderIcon } from "./icons";

const invitees = [
  {
    name: "શ્રી મહાવીરસિંહ બાવુભા ઝાલા",
    relation: "કુંવરશ્રીના દાદાશ્રી",
    family: "zala",
    path: "/images/tirth_Gfather.jpeg",
  },
  {
    name: "શ્રીમતી કુમુદબા મહાવીરસિંહ ઝાલા",
    relation: "કુંવરશ્રીના દાદીશ્રી",
    family: "zala",
    path: "/images/tirth_ba.jpeg",
  },

  {
    name: "સ્વ. દિલીપસિંહ રામુભા જાડેજા",
    relation: "કુંવરીબાના દાદાશ્રી",
    family: "jadeja",
    path: "/images/bhavyatadada.jpg",
  },
  {
    name: "શ્રીમતી મોહનબા દિલીપસિંહ જાડેજા",
    relation: "કુંવરીબાના બાશ્રી",
    family: "jadeja",
    path: "/images/bhavyataba_Gmother.jpeg",
  },

  {
    name: "શ્રી હિતેન્દ્રસિંહ મહાવીરસિંહ ઝાલા",
    relation: "કુંવરશ્રીના પિતાશ્રી",
    family: "zala",
    path: "/images/tirth_father.jpeg",
  },
  {
    name: "અ.સૌ. શ્રી વૈશાલીબા હિતેન્દ્રસિંહ ઝાલા",
    relation: "કુંવરશ્રીના માતાશ્રી",
    family: "zala",
    path: "/images/tirth_mummy.jpeg",
  },

  {
    name: "શ્રી રાજેન્દ્રસિંહ દિલીપસિંહ જાડેજા",
    relation: "કુંવરીબાના પિતાશ્રી",
    family: "jadeja",
    path: "/images/bhavyata_father.jpeg",
  },
  {
    name: "અ.સૌ. શ્રી અન્નપૂર્ણાબા રાજેન્દ્રસિંહ જાડેજા",
    relation: "કુંવરીબાના માતાશ્રી",
    family: "jadeja",
    path: "/images/bhavyataba_mother.jpeg",
  },

  {
    name: "શ્રી બ્રિજરાજસિંહ હિતેન્દ્રસિંહ ઝાલા",
    relation: "કુંવરશ્રીના ભાઈશ્રી",
    family: "zala",
    path: "/images/tirth_bhai.jpeg",
  },
  {
    name: "અ.સૌ. શ્રી હિનાબા બ્રિજરાજસિંહ ઝાલા",
    relation: "કુંવરશ્રીના ભાભીશ્રી",
    family: "zala",
    path: "/images/tirth_bhabhi.jpeg",
  },
  {
    name: "સ્વ. વિવેકબા મહાવીરસિંહ ઝાલા ",
    relation: "કુંવરશ્રીના ફૈબાસાહેબ",
    family: "zala",
    path: "/images/tirth_faiba1.jpg",
  },
  {
    name: "શ્રી રુદ્રાક્ષસિંહ બ્રિજરાજસિંહ ઝાલા",
    relation: "કુંવરશ્રીના ભત્રીજાશ્રી",
    family: "zala",
    path: "/images/rudraksh.jpeg",
  },
  {
    name: "શ્રી આર્યરાજસિંહ રાજેન્દ્રસિંહ જાડેજા",
    relation: "કુંવરીબાના  ભાઈશ્રી",
    family: "jadeja",
    path: "/images/bhavyataba_brother.jpeg",
  },
];

const StyledCard = styled(Card)(({ theme }) => ({
  position: "relative",
  width: "100%",
  maxWidth: "400px",
  height: "340px",
  overflow: "hidden",
  borderRadius: "12px",
}));

const CardOverlay = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-end",
  padding: "2px",
}));

const Invitors = () => {
  const [activeFilter, setActiveFilter] = useState("zala");

  return (
    <Container className="py-5">
      <div className="text-center position-relative mb-3">
        <h1 className="display-4" style={{ padding: "0px" }}>
          નિમંત્રક
        </h1>
      </div>
      <Row className="justify-content-center mb-4">
        <Col xs={12} className="text-center" style={{ padding: "0px" }}>
          <Button
            className="mr-1"
            variant={activeFilter === "zala" ? "contained" : "outlined"}
            sx={{
              bgcolor: activeFilter === "zala" ? "#EA8FB6" : "transparent",
              color: activeFilter === "zala" ? "white" : "#EA8FB6",
              borderColor: "#EA8FB6",
              padding: "5px 12px",
              "&:hover": {
                bgcolor: "#e07aa6",
                borderColor: "#e07aa6",
                color: "white",
              },
            }}
            onClick={() => setActiveFilter("zala")}
          >
            ઝાલા પરિવાર (ભડવાણા)
          </Button>

          <Button
            className="ml-1"
            variant={activeFilter === "jadeja" ? "contained" : "outlined"}
            sx={{
              bgcolor: activeFilter === "jadeja" ? "#EA8FB6" : "transparent",
              color: activeFilter === "jadeja" ? "white" : "#EA8FB6",
              borderColor: "#EA8FB6",
              padding: "5px 12px",
              "&:hover": {
                bgcolor: "#e07aa6",
                borderColor: "#e07aa6",
                color: "white",
              },
            }}
            onClick={() => setActiveFilter("jadeja")}
          >
            જાડેજા પરિવાર (ભુણાવા)
          </Button>
        </Col>
      </Row>
      <Row className="justify-content-center m-3" style={{ gap: "1rem" }}>
        {invitees
          .filter((invitee) => invitee.family === activeFilter)
          .map((invitee, index) => (
            <StyledCard key={index}>
              {invitee?.path && (
                <img
                  style={{ height: "auto", width: "100%", objectFit: "cover"}}
                  src={invitee.path}
                  alt={`Name of ${invitee.name}`}
                />
              )}
              <CardOverlay>
                <CardContent sx={{ padding: "12px" }}>
                  <Typography
                    sx={{ fontSize: "1.3rem", margin: "0px" }}
                    variant="h5"
                    color="white"
                    gutterBottom
                  >
                    {invitee.name}
                  </Typography>
                  <Typography
                    sx={{ padding: "0px", margin: "0px" }}
                    variant="subtitle1"
                    color="white"
                    gutterBottom
                  >
                    {invitee.relation}
                  </Typography>
                </CardContent>
              </CardOverlay>
            </StyledCard>
          ))}
      </Row>
    </Container>
  );
};

export default Invitors;
